
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/newsroom/[newsId]",
      function () {
        return require("private-next-pages/media/newsroom/[newsId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/newsroom/[newsId]"])
      });
    }
  